import { api_url } from "../../utils/constants";
const axios = require('axios').default;

// Team member accounts (userAccountType "Team"): login, the member's own team
// and the self-managed extras. The SP's team console lives in
// api/service-provider/team-console-api.js.
//
// The team endpoints answer an error with HTTP 4xx and {message}; teamErrorMessage
// pulls that out for display.

const authHeaders = () => ({ 'Authorization': 'Bearer ' + window.localStorage.getItem('jwtToken') })

const request = (config) => {
    return new Promise((resolve, reject) => {
        axios(config)
        .then(
            (response) => {
                resolve(response.data);
            }, (error) => {
                console.log(error);
                reject(error);
            }
        )
    });
}

export const teamErrorMessage = (error, fallback = "Please try again. If problem persists, contact us at support@stringssg.com") =>
    error?.response?.data?.message || fallback

// ---------------------------------------------------------------- login (public)

// {responseCode, channel}: 1 PIN sent, 0 not an active team member, 3 asked less than a minute ago;
// channel whatsapp | sms
export const teamMobileLogin = (countryTelCd, mobileNumber) => request({
    method : "POST",
    url :  api_url + "/public/TeamMobileLogin",
    params : { countryTelCd, mobileNumber },
})

// Same shape as /public/ValidateMobileLoginOTP: {message, userEmail, loginToken, jwtToken, isTeam}
export const validateTeamMobileLoginOTP = (countryTelCd, mobileNumber, pin) => request({
    method : "POST",
    url :  api_url + "/public/ValidateTeamMobileLoginOTP",
    params : { countryTelCd, mobileNumber, pin },
})

// "Send by SMS instead" after the PIN went on WhatsApp. {responseCode: 1 sent | 0 refused}
export const resendTeamLoginOtpBySms = (countryTelCd, mobileNumber) => request({
    method : "POST",
    url :  api_url + "/public/ResendTeamLoginOtpBySms",
    params : { countryTelCd, mobileNumber },
})

export const teamPasswordLogin = (email, password) => request({
    method : "POST",
    url :  api_url + "/public/TeamPasswordLogin",
    params : { email, password },
})

// ---------------------------------------------------------------- the member

export const setTeamLoginPassword = (email, password) => request({
    method : "POST",
    url :  api_url + "/SetTeamLoginPassword",
    params : { email, password },
    headers : authHeaders(),
})

// {member, teamId, teamName, teamRole, selfManaged, spUserId, spName, businessName, serviceAreas[], availability[]}
export const getMyTeam = () => request({
    method : "GET",
    url :  api_url + "/GetMyTeam",
    headers : authHeaders(),
})

// notifyNewRequests: "Y" | "N"
export const updateMyTeamSettings = (notifyNewRequests) => request({
    method : "POST",
    url :  api_url + "/UpdateMyTeamSettings",
    params : { notifyNewRequests },
    headers : authHeaders(),
})

// Dates YYYY-MM-DD -> [ { teamId, teamName, days: [{ date, timeOff: [...], sessions: [...] }] } ]
export const downloadMyTeamCalendar = (startDate, endDate) => request({
    method : "GET",
    url :  api_url + "/DownloadMyTeamCalendar",
    params : { startDate, endDate },
    headers : authHeaders(),
})

// ---------------------------------------------------------------- self-managed teams

// Same PeopleRequestModel[] as /DownloadPeopleRequest
export const downloadTeamPeopleRequest = (upperLimit, lowerLimit) => request({
    method : "GET",
    url :  api_url + "/DownloadTeamPeopleRequest",
    params : { upperLimit, lowerLimit },
    headers : authHeaders(),
})

export const requestJobCancellation = (jobIdInt, reason) => request({
    method : "POST",
    url :  api_url + "/RequestJobCancellation",
    params : { jobIdInt, reason: reason || "" },
    headers : authHeaders(),
})

// Team lead only. windows: [{ dayOfWeek: 1-7 (Mon=1), startTime: "09:00", endTime: "18:00" }] (replaces all)
export const saveMyTeamAvailability = (windows) => request({
    method : "POST",
    url :  api_url + "/SaveMyTeamAvailability",
    data : { windows },
    headers : { "Content-Type": "application/json", ...authHeaders() },
})

// No times = the whole day
export const addMyTeamTimeOff = (offDate, startTime, endTime, reason) => {
    const params = { offDate }
    if (startTime) params.startTime = startTime
    if (endTime) params.endTime = endTime
    if (reason) params.reason = reason
    return request({
        method : "POST",
        url :  api_url + "/AddMyTeamTimeOff",
        params,
        headers : authHeaders(),
    })
}

export const deleteMyTeamTimeOff = (timeOffId) => request({
    method : "POST",
    url :  api_url + "/DeleteMyTeamTimeOff",
    params : { timeOffId },
    headers : authHeaders(),
})
